import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Preloader.css";
import Logo from "../../assets/img/logo.svg";

const WEIGHTED = [0.16, 1, 0.3, 1];
const UNVEIL   = [0.19, 1, 0.22, 1];

const Preloader = ({ onLoadingComplete, loadingDuration = 2800 }) => {
  const [exit, setExit] = useState(false);

  useEffect(() => {
    // Respect document readyState, but enforce a minimum display time
    const trigger = () => {
      const elapsed = Date.now() - mountTime;
      const remaining = Math.max(0, loadingDuration - elapsed);
      setTimeout(() => setExit(true), remaining);
    };

    const mountTime = Date.now();

    if (document.readyState === "complete") {
      trigger();
    } else {
      window.addEventListener("load", trigger, { once: true });
      // Fallback — never block longer than loadingDuration
      const fallback = setTimeout(() => setExit(true), loadingDuration);
      return () => {
        window.removeEventListener("load", trigger);
        clearTimeout(fallback);
      };
    }
  }, [loadingDuration]);

  return (
    <AnimatePresence onExitComplete={() => onLoadingComplete?.()}>
      {!exit && (
        <motion.div
          className="preloader"
          key="preloader"
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: WEIGHTED }}
          aria-hidden="true"
        >
          {/* Film grain */}
          <div className="preloader-grain" />

          <div className="preloader-stage">
            {/* Logo clip-path reveal */}
            <div className="preloader-logo-wrap">
              <motion.img
                src={Logo}
                alt=""
                className="preloader-logo"
                initial={{ clipPath: "inset(100% 0 0 0)" }}
                animate={{ clipPath: "inset(0% 0 0 0)" }}
                transition={{ duration: 1.6, ease: UNVEIL, delay: 0.2 }}
              />

              {/* Precision laser line — tracks the reveal edge */}
              <motion.div
                className="preloader-tracer"
                initial={{ bottom: "0%" }}
                animate={{ bottom: "100%" }}
                transition={{ duration: 1.6, ease: UNVEIL, delay: 0.2 }}
              />
            </div>

            {/* Wordmark */}
            <motion.p
              className="preloader-wordmark"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, ease: WEIGHTED, delay: 0.6 }}
            >
              Carrosserie Kris
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;
